import { Thread, ThreadUser } from '@schooly/api';
import { useCallback } from 'react';

import { useThreads } from './ThreadContext';

export type UseSelectThreadParams = {
  currentUser: ThreadUser;
  onThreadCreated?: (thread: Thread) => void;
};

export const useSelectThread = ({ currentUser, onThreadCreated }: UseSelectThreadParams) => {
  const { connectedUser, addSpectator, connectUser, selectThread, createThreadChannel } =
    useThreads();

  return useCallback(
    async (thread: Thread) => {
      let current: Thread = thread;

      if (!current.channel) {
        current = await createThreadChannel(current);
        onThreadCreated?.(current);
      }

      const isNotMember = !current.channel?.members.find(
        (m) => m.user.user_id === currentUser.user_id,
      );

      if (isNotMember) {
        current = await addSpectator(current, currentUser);
      }

      if (!connectedUser) {
        await connectUser(currentUser);
      }

      await selectThread(current);
    },
    [
      createThreadChannel,
      addSpectator,
      connectUser,
      selectThread,
      connectedUser,
      currentUser,
      onThreadCreated,
    ],
  );
};
